import development from '@/assets/phases/development.png'
import implementation from '@/assets/phases/implementation.png'
import maintenance from '@/assets/phases/maintenance.png'
import management from '@/assets/phases/management.png'
import planning from '@/assets/phases/planning.png'

export default { development, implementation, maintenance, management, planning }